import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Center, HStack, Spacer, Text, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { Sponsors } from "./sponsors";
import { Role, useSessionState } from "../Session/SessionService";
import { useState } from "react";
import { PlusIcon, WrenchIcon } from "lucide-react";
import AdminToolbar from "../Components/Admin/AdminToolbar";
import { Sponsor } from "../Api/dto/Sponsors";
import { useAwaitResponse } from "../Api/HttpRequestHelpers";
import { sponsorClient } from "../Api/BackendClient2";
import { competitionBaseSponsorType, hiddenSponsorType, ModifySponsors } from "./modify_sponsors";


export const SponsorsPage = (props: {
  //main: Array<string>;
  //hinderbana: Array<string>;
  ////others: Array<string>;
  //mainHeading?: string;
  //otherHeading?: string;
  //hinderHeading?: string;
}) => {
  const mainHeading: string = "Tack för att ni sponsrar Östhammar friidrott!";
  const otherHeading: string = "";
  const hinderHeading: string = "";


  const [sponsors, isLoadingSponsors, setSponsors] = useAwaitResponse(
    [],
    () => sponsorClient.getSponsors(),
    (response) => response 
  );


  const session = useSessionState();
  const [modify, setModify] = useState(false);
  const [add, setAdd] = useState(false);


  return (
    <>
      <Breadcrumb mb={8}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="..">
            Start
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>Sponsorer</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <AdminToolbar
        onOpen={() => {setModify(true);}}
        onClose={() => {setModify(false);}}
        hidden={!session.hasUserMode(Role.ADMIN)}
      >
          <Text fontSize={"2xl"} textColor={"white"} >Lägg till, ändra eller ta bort sponsorer</Text>
          <Spacer/>
      </AdminToolbar>


      {
        modify ? 
        <ModifySponsors
          sponsors={sponsors}
          onAdded={(newSponsor) => {
            setSponsors((prev) => [...prev, newSponsor]);
          }}
        />
        :
        <Sponsors
          sponsors={
            sponsors
            .filter(s => s.context !== hiddenSponsorType)
            .map(s => ({ ...s, context: competitionBaseSponsorType}))
          }
          mainHeading={mainHeading}
          otherHeading={otherHeading}
          hinderHeading={hinderHeading}
        />
      }
    </>
  );
};

